/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { Modal, FormControl, Button, FormGroup } from 'react-bootstrap'
import { useForm, Controller, SubmitHandler } from 'react-hook-form'
import { useTheme } from 'styled-components'

import globalNotification from 'live/services/global-notification'
import i18n from 'live/services/i18n'

import { RoundedModal } from '../RoundedModal/RoundedModal'
import { RemoveTextModal } from './styles'

interface IProps {
    message: string
    show: boolean
    setShow: (b: boolean) => void
    handleClose?: () => void
    onDelete: () => Promise<void>
    removalMessage: string
    type: 'resource' | 'resource type' | 'basic info' | 'avatar' | 'resource group'
    confirmationMessage: string
}

interface IFormData {
    deleteConfirmation: string
}
export function RemoveConfirmationModal({
    show,
    handleClose,
    onDelete,
    removalMessage,
    type,
    setShow,
    message,
    confirmationMessage
}: IProps): JSX.Element {
    const theme = useTheme()
    const [loading, setLoading] = useState(false)
    const { handleSubmit, control, formState, setValue, reset } = useForm<IFormData>({
        mode: 'all',
        defaultValues: { deleteConfirmation: '' }
    })

    const handleCloseProtocol = (): void => {
        setValue('deleteConfirmation', '')
        handleClose()
    }
    const handleDelete: SubmitHandler<IFormData> = async (): Promise<void> => {
        // add remove here already beeing valadated of typing REMOVE
        try {
            setLoading(true)
            await onDelete()
            handleCloseProtocol()
            globalNotification.success(i18n(confirmationMessage))
        } catch (err) {
            globalNotification.error(i18n(err.message ?? 'Error on delete.'))
        } finally {
            setLoading(false)
        }
    }
    useEffect(() => {
        reset()
    }, [show])

    return (
        <RoundedModal show={show} onHide={() => setShow(false)} aria-labelledby="contained-modal-title">
            <form onSubmit={handleSubmit(handleDelete)}>
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title" style={{ color: theme['red-500'] }}>
                        <i className="fa fa-exclamation-circle" style={{ marginRight: '4px' }} />
                        {i18n(`Delete ${type}`)}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <RemoveTextModal className="remove-text">
                        <div>{removalMessage}</div>
                        <div className="red-text">{i18n('This action cannot be undone.')}</div>
                        <div>{i18n('Features that read this list will be affected.')}</div>
                        <div>
                            {message} <span className="red-text">{i18n('REMOVE')}</span>{' '}
                            {i18n('in the field below before completing the action:')}
                        </div>
                    </RemoveTextModal>
                    <Controller
                        rules={{ required: true, validate: v => v === i18n('REMOVE') }}
                        name="deleteConfirmation"
                        control={control}
                        render={({ field, fieldState }) => (
                            <FormGroup validationState={fieldState.error ? 'error' : 'success'}>
                                <FormControl
                                    type="text"
                                    ref={field.ref}
                                    onChange={field.onChange}
                                    onBlur={field.onBlur}
                                    value={field.value}
                                />
                            </FormGroup>
                        )}
                    />
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        className="no-outline-button"
                        bsStyle="danger"
                        type="submit"
                        disabled={!formState.isValid || loading}
                    >
                        {loading ? i18n('Deleting...') : i18n('Confirm deletion')}
                    </Button>
                    <Button
                        className="no-outline-button"
                        type="button"
                        onClick={() => setShow(false)}
                        disabled={loading}
                    >
                        {i18n('No, I do not')}
                    </Button>
                </Modal.Footer>
            </form>
        </RoundedModal>
    )
}
